export enum InputFieldType {
  Text = 'text',
  Password = 'password',
  Number = 'number',
  Date = 'date',
  Phone = 'phone',
}
